import React from 'react';
export function TopBar() {
  return <div className="fixed top-0 left-0 right-0 z-50 bg-[#FF9F43] text-white py-2 md:py-3 px-4 text-center shadow-md" data-id="element-144">
      <p className="text-xs md:text-base font-bold tracking-wide" data-id="element-145">
        🔥 ¡OFERTA DE LANZAMIENTO! 75% DE DESCUENTO SOLO POR HOY. PRECIO FINAL:
        $19.999
      </p>
    </div>;
}